export default "__VITE_ASSET__B0n7yeOh__"